<template>
  <div class="mc-field-status">
    <span
      v-if="item.status?.color"
      class="__status-dots"
      :style="{ backgroundColor: item.status.color }"
    ></span>
    <span style="color: $mep-color-text-400">{{ item.status.name }}</span>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
<style lang="scss">
.mc-field-status {
  .__status-dots {
    display: inline-block;
    margin: auto;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
  }
}
</style>